import { useEffect } from 'react';
import { LelandPanel } from '../../components/Leland';
import { useTenant } from '../../components/Shell';
import { PageHeader } from '../../components/ui';
import { useLeland } from '../../lib/leland';

/** Leland, full size: the same conversation as the floating panel. */
export function LelandPage() {
  const { tenant } = useTenant();
  const l = useLeland();
  // One place at a time: the floating panel closes while this page is open.
  useEffect(() => {
    l?.setOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <PageHeader eyebrow={tenant.name} title="Leland" />
      <div className="content leland-page">
        <LelandPanel variant="page" base={`/t/${encodeURIComponent(tenant.domain)}`} />
      </div>
    </>
  );
}
